import { v4 as uuidv4 } from "uuid";
function chillHop() {
  return [
    {
      name: '스물다섯, 스물하나',
      artist: '자우림',
      cover: `${process.env.PUBLIC_URL}/images/song_one.png`,
      id: uuidv4(),
      active: false,
      color: ['#6F9099', '#B5DEF4'],
      audio: `${process.env.PUBLIC_URL}/audio/song_one.mp3`
    },
    {
      name: '모든 날, 모든 순간',
      artist: '폴킴',
      cover: `${process.env.PUBLIC_URL}/images/song_two.jpg`,
      id: uuidv4(),
      active: false,
      color: ['#A1C1B9', '#CFDCD5'],
      audio: `${process.env.PUBLIC_URL}/audio/song_two.mp3`
    },
    {
      name: '홀로',
      artist: '정키',
      cover: `${process.env.PUBLIC_URL}/images/song_three.jpg`,
      id: uuidv4(),
      active: false,
      color: ['#E1308A', '#973E95'],
      audio: `${process.env.PUBLIC_URL}/audio/song_three.mp3`
    },
    {
      name: '봄,사랑,벚꽃 말고',
      artist: '하이포, 아이유',
      cover: `${process.env.PUBLIC_URL}/images/song_four.jpg`,
      id: uuidv4(),
      active: false,
      color: ['#D8C2A3', '#CFAF7A'],
      audio: `${process.env.PUBLIC_URL}/audio/song_four.mp3`
    },
    {
      name: '금요일에 만나요',
      artist: '아이유',
      cover: `${process.env.PUBLIC_URL}/images/song_five.jpg`,
      id: uuidv4(),
      active: false,
      color: ['#C3A484', '#C0946C'],
      audio: `${process.env.PUBLIC_URL}/audio/song_five.mp3`
    },
    {
      name: '한숨',
      artist: '이하이',
      cover: `${process.env.PUBLIC_URL}/images/song_six.jpg`,
      id: uuidv4(),
      active: false,
      color: ['#EFB8B0', '#F2BFBC'],
      audio: `${process.env.PUBLIC_URL}/audio/song_six.mp3`
    },
    {
      name: '너에게 난 나에게 넌',
      artist: '자전거탄풍경',
      cover: `${process.env.PUBLIC_URL}/images/song_seven.jpg`,
      id: uuidv4(),
      active: false,
      color: ['#FFFFFF', '#000105'],
      audio: `${process.env.PUBLIC_URL}/audio/song_seven.mp3`
    },
    {
      name: '시차',
      artist: '우원재',
      cover: `${process.env.PUBLIC_URL}/images/song_eight.jpg`,
      id: uuidv4(),
      active: false,
      color: ['#1438D4', '#BA4D36'],
      audio: `${process.env.PUBLIC_URL}/audio/song_eight.mp3`
    },
    {
      name: '주지마',
      artist: '로꼬 (Loco), 화사 (마마무)',
      cover: `${process.env.PUBLIC_URL}/images/song_nine.jpg`,
      id: uuidv4(),
      active: false,
      color: ['#6F3F24', '#573C33'],
      audio: `${process.env.PUBLIC_URL}/audio/song_nine.mp3`
    }
  ];
}

export default chillHop;